/** Default session var for plain-text replies (webhook parser output). */
export const DEFAULT_CAPTURE_VAR = 'last_message';

export function normalizeCaptureVar(name) {
  const v = String(name || '').trim();
  return v || DEFAULT_CAPTURE_VAR;
}
